import React, { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import style from "../style.module.scss";

const Badge = ({ item }: any) => {
  // state for set hover on tooltip
  const [show, setShow] = useState(false);
  return (
    // overlay for tooltip
    <OverlayTrigger
      placement={"right-start"}
      show={show}
      overlay={
        <Tooltip
          show={show}
          onMouseEnter={() => {
            setShow(true);
          }}
          onMouseLeave={() => {
            setShow(false);
          }}
        >
          <p className={style.tool_tip_text}>
            {item.toolTipText}
            <a
              href={item.tooltipLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.toolTipLinkText}
            </a>
          </p>
        </Tooltip>
      }
    >
      <div
        style={{ backgroundColor: item.color }}
        className={style.special_tags}
        onMouseEnter={() => {
          setShow(true);
        }}
        onMouseLeave={() => {
          setShow(false);
        }}
      >
        <label>{item.text}</label>
      </div>
    </OverlayTrigger>
  );
};

export default Badge;
